



















































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { format, endOfDay, parse } from 'date-fns'
// TODO check if ok
// import endOfDay from 'date-fns/end_of_day'
// import parse from 'date-fns/parse'

// Mixins
import DateMixin from '@/mixins/Date'

@Component
export default class DateRanger extends Mixins(DateMixin) {

  start: Date = null
  end: Date = null
  months: string[] = []
  days: string[] = []
  selectedDatepicker: string = null
  $refs: {
    dateranger: any
  }

  datepickers = [
    {
      type: 'start',
      selected: false
    },
    {
      type: 'end',
      selected: false
    },
  ]

  @Prop({ default: null }) startDate
  @Prop({ default: null }) endDate


  @Getter('locale', { namespace: 'user' }) locale

  rangeLabel(type): string {
    return this.$t(`global.datepicker.${type}_range`) as string
  }

  @Watch('startDate', { immediate: true })
  updateStartDate(date) {
    this.start = date ? parse(date) : null
  }

  @Watch('endDate')
  updateEndDate(date) {
    this.end = date ? parse(date) : null
  }

  @Watch('locale', { immediate: true })
  updateLocale() {
    this.setLocale()
  }

  @Watch('start')
  emitStartEvent() {
    if (!this.end) {
      this.showDatepicker('end')
    }
    this.$emit('start', {
      start: this.start ? this.start.toISOString() : null,
      end: this.end ? endOfDay(this.end).toISOString() : null
    })
  }

  @Watch('end')
  emitEndEvent() {
    this.$emit('end', {
      start: this.start ? this.start.toISOString() : null,
      end: this.end ? endOfDay(this.end).toISOString() : null
    })
    if (this.start) {
      this.$refs.dateranger.toggle()
    }
  }

  showDatepicker(type) {
    this.selectedDatepicker = type
  }

  get maxStartDate() {
    return this.end ? this.end : new Date()
  }

  get minEndDate() {
    return this.start ? this.start : null
  }

  get maxEndDate() {
    return new Date()
  }

  get formatedStart() {
    return this.formatedDate(this.start, 'D MMM YY')
  }

  get formatedEnd() {
    return this.formatedDate(endOfDay(this.end), 'D MMM YY')
  }

  get formatedStartWithHours() {
    return this.formatedDate(this.start, 'D MMM YY - HH:mm')
  }

  get formatedEndWithHours() {
    return this.formatedDate(endOfDay(this.end), 'D MMM YY - HH:mm')
  }

  setLocale() {
    this.months = (this.$t('global.datepicker.month_names') as string).split(',')
    this.days = (this.$t('global.datepicker.days_names') as string).split(',')
  }
}
